import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {getFlatActiveTeammates} from '../../../../store/data/teammates/teammatesSelectors';
import {TeammateCell} from './teammateCell';

/*
 * Props.
 */

interface TeammateCellContainerProps {
  teammateId?: number;
  teammateEmail?: string;
}

/*
 * Selectors.
 */

function getTeammateId(_state: AppState, props: TeammateCellContainerProps) {
  return props.teammateId;
}

function getTeammateEmail(_state: AppState, props: TeammateCellContainerProps) {
  return props.teammateEmail;
}

function makeGetTeammate() {
  return createSelector([getTeammateId, getTeammateEmail, getFlatActiveTeammates], (id, email, teammates) => {
    if (email) {
      return teammates.find((teammate) => teammate.email === email);
    }
    if (id) {
      return teammates.find((teammate) => teammate.id === id);
    }
    return undefined;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<TeammateCellContainerProps>()(() => ({
  value: makeGetTeammate(),
}));

export const TeammateCellContainer = connect(mapStateToProps, null)(TeammateCell);
